<template>
  <div class="poster-box">
    <img class="img-poster"
      src="../../assets/interest/bg_share.jpg">
    <!-- 雷达图 -->
    <div class="chart-container"></div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/radar'
import html2canvas from '../../utils/html2canvas'

export default {
  data () {
    return {
    }
  },
  mounted () {
    // 初始化
    this.init()
  },
  methods: {
    // 初始化
    init () {
      const el = document.querySelector('.chart-container')
      const chart = echarts.init(el)
      chart.setOption({
        backgroundColor: 'rgba(255, 255, 255, 0)',
        radar: {
          name: {
            textStyle: {
              color: '#c4fff7',
              borderRadius: 3,
              fontSize: 15
            }
          },
          radius: 60,
          center: ['50%', '50%'],
          indicator: [
            { name: '身体活动强度', max: 10 },
            { name: '心理健康', max: 10 },
            { name: '肠道健康', max: 10 },
            { name: '睡眠质量', max: 10 },
            { name: '饮食习惯', max: 10 }
          ]
        },
        series: [{
          type: 'radar',
          symbol: 'none',
          itemStyle: {
            normal: {
              lineStyle: {
                color: '#c4fff7'
              },
              areaStyle: {
                color: 'rgba(219, 230, 255, 0.6)'
              }
            }
          },
          data: [
            {
              value: [1, 9, 7, 8, 9]
            }
          ]
        }]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/core.scss";

.poster-box {
  box-sizing: border-box;
  position: relative;
  margin: 0;
  padding: 0;
  .img-poster {
    display: block;
    font-size: 0;
    width: 100%;
  }
  .chart-container {
    height: 200px;
    position: absolute;
    top: 200px;
    left: 0px;
    width: 200px;
  }
}
</style>
